var map = {
	"./bg-login-page-dark.svg": "c5ac",
	"./bg-login-page.svg": "b946",
	"./error-illustration.svg": "9487",
	"./illustration.svg": "643f",
	"./logo.png": "9d64",
	"./placeholders/200x200.jpg": "f866",
	"./placeholders/800x800.jpg": "f46d",
	"./s-vip.jpg": "9076"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";